module.exports = require("axios");


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 5
// module chunks = 0